import { format } from "date-fns";

export type DateFormatType = 'date' | 'datetime';

export const formatDate = (dateString: string, formatType: DateFormatType = 'date') => {
    const formatString = formatType === 'datetime' ? 'PP, pp' : 'PP';
    return format(new Date(dateString), formatString);
};